import { useEffect, useRef } from "react";

interface ConfirmationDialogProps {
  busy: boolean;
  confirmLabel: string;
  description: string;
  onCancel: () => void;
  onConfirm: () => void;
  title: string;
}

export function ConfirmationDialog({
  busy,
  confirmLabel,
  description,
  onCancel,
  onConfirm,
  title,
}: ConfirmationDialogProps) {
  const cancelButton = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    cancelButton.current?.focus();
  }, []);

  return (
    <div className="confirmation-backdrop" role="presentation">
      <section
        aria-describedby="confirmation-description"
        aria-labelledby="confirmation-title"
        aria-modal="true"
        className="confirmation-dialog"
        onKeyDown={(event) => {
          event.stopPropagation();
          if (event.key === "Escape" && !busy) onCancel();
        }}
        role="alertdialog"
      >
        <h3 id="confirmation-title">{title}</h3>
        <p id="confirmation-description">{description}</p>
        <div className="modal-actions">
          <button ref={cancelButton} disabled={busy} onClick={onCancel} type="button">
            取消
          </button>
          <button disabled={busy} onClick={onConfirm} type="button">
            {busy ? "正在处理…" : confirmLabel}
          </button>
        </div>
      </section>
    </div>
  );
}
